import {CookieService} from '../services/cookie.service';

/**
 * This class is responsible for catching the first visited page URL and storing it in a cookie.
 * !IMPORTANT there is a similiar/equal class for b2b, consider updating / keeping it in sync
 */
export class FirstPageVisitCatcher {
    static readonly NAME = 'first_visited_page_url';
    public saveFirstPageVisited(): void {
        if (!this.getUrlFromCookies()) {
            this.setCookieUrl();
        }
        if (!this.getUrlFromStorage()) {
            this.setStorageUrl();
        }
    }

    private getUrlFromCookies(): string | undefined {
        const cookie = CookieService.getCookie(FirstPageVisitCatcher.NAME);
        if (cookie) {
            return cookie[2];
        }
        return undefined;
    }

    private getUrlFromStorage(): string | undefined {
        let value: string | null = null;
        try {
            value = localStorage.getItem(FirstPageVisitCatcher.NAME);
        } catch {
            // localStorage inaccessible
        }
        if (value === null) {
            try {
                return sessionStorage.getItem(FirstPageVisitCatcher.NAME) ?? undefined;
            } catch {
                return undefined;
            }
        }
        return value ?? undefined;
    }

    private setCookieUrl(): void {
        CookieService.setCookie(FirstPageVisitCatcher.NAME, window.location.href, 7);
    }

    private setStorageUrl(): void {
        try {
            localStorage.setItem(FirstPageVisitCatcher.NAME, window.location.href);
        } catch {
            try {
                sessionStorage.setItem(FirstPageVisitCatcher.NAME, window.location.href);
            } catch {
                // Storage blocked in this context (e.g. Safari with cookies disabled, private mode)
            }
        }
    }
}

const firstPageVisitCatcher = new FirstPageVisitCatcher();
window.addEventListener('load', () => {
    firstPageVisitCatcher.saveFirstPageVisited();
});
